import types from './types';

// const clearAuth = () => ({
//   type: types.CLEAR_SEARCH
// })


const updateCurrentChat = id => ({
	type: types.UPDATE_CURRENT_CHAT,
	payload: id
});

const updateCategories = (data) => ({
	type: types.UPDATE_CATEGORIES,
	payload: data
})

const updateSchedule = (category, data) => ({
	type: types.UPDATE_CATEGORIES,
	payload: {category, schedule: data}
})

const updateDate = (date) => ({
	type: types.UPDATE_CURRENT_DATE,
	payload: date
})

const updateStaged = (data) => ({
	type: types.UPDATE_STAGED_CHANGES,
	payload: data
})

const resetStaged = () => ({
	type: types.RESET_STAGED_CHANGES,
})

const updateToth = (data) => ({
	type: types.UPDATE_TOTH,
	payload: data
})

// For use by home screen to preload toth schedules
// data: {toth: <toth schedule>, date: <dateString>}
const updateTothForDate = (data) => ({
	type: types.UPDATE_TOTH_FOR_DATE,
	payload: data
})

const updateSelectedDate = (date) => ({
	type: types.UPDATE_SELECTED_DATE,
	payload: date
})

export default {
	// clearSearch,
	updateCurrentChat,
	updateCategories,
	updateSchedule,
	updateDate,
	updateStaged,
	resetStaged,
	updateToth,
	updateTothForDate,
	updateSelectedDate
};
